module.exports = __webpack_public_path__ + "img/garden.4fc5289f.png";